import styled from 'styled-components'
import AntdTable from 'antd/lib/table'

export const Text = styled.div`
  min-width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Table = styled(AntdTable)`
  .ant-table-thead > tr > th {
    padding: 4px 4px;
  }

  .ant-table-tbody > tr > td {
    font-size: x-small;
    padding: 4px 4px;
  }
`
export const Total = styled.div`
  text-align: end;
  padding: 4px 24px;
`
